// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"128":"c78e6790a50ca0eb02a1","681":"c78e6790a50ca0eb02a1"}[chunkId] + ".chunk.css";
};